import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { PATH } from '../../../../../constants';
import './Home.css';

// NOTE - size values related to Content + SideMenu
const SCROLL_OFF = 50; // fow scrollbar fix (clientWidth is different than max-width in css)
const LIMITS = [2000 - SCROLL_OFF, 1700 - SCROLL_OFF];
const HEIGHT = [1200, 1000, 850];
const BG_W = 2626;
const BG_H = 1967;
const BGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

class Home extends Component {
  constructor(props) {
    super(props);
    this.swapTimer = null;

    this.state = {
      loadBgs: false,
      activeBg: Math.round(Math.random() * (BGS.length - 1)),
      bgW: 0,
      bgH: 0,
      bgTop: 0,
      bgLeft: 0,
    };

    this.homeRef = React.createRef();

    this.handleResize = this.handleResize.bind(this);
  }

  // -----------------------------------------------------------------------------------
  // Lifecycle
  // -----------------------------------------------------------------------------------

  componentDidMount() {
    this.startLoadTimeout();

    this.sizeUpdate();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    this.endSwapTimer();
    this.endLoadTimeout();

    window.removeEventListener('resize', this.handleResize);
  }

  // -----------------------------------------------------------------------------------
  // Start timer
  // -----------------------------------------------------------------------------------

  startLoadTimeout() {
    this.startTimeout = setTimeout(() => {
      this.startTimeoutComplete();
    }, 5000);
  }

  startTimeoutComplete() {
    this.setState({
      loadBgs: true,
    });
    this.startTimeout = setTimeout(() => {
      this.startSwapTimer();
    }, 2000);
  }

  endLoadTimeout() {
    clearInterval(this.startTimeout);
  }

  // -----------------------------------------------------------------------------------
  // Swap timer
  // -----------------------------------------------------------------------------------

  startSwapTimer() {
    this.swapTick();
    this.swapTimer = setInterval(() => {
      this.swapTick();
    }, 6000);
  }

  endSwapTimer() {
    clearInterval(this.swapTimer);
  }

  swapTick() {
    const { activeBg } = this.state;
    const { match } = this.props;
    const { isExact } = match;

    // call only on home page
    if (isExact) {
      let newId = activeBg + 1;
      if (newId === BGS.length) {
        newId = 0;
      }
      this.setState({
        activeBg: newId,
      });
    }
  }

  // -----------------------------------------------------------------------------------
  // Resize
  // -----------------------------------------------------------------------------------

  handleResize() {
    this.sizeUpdate();
    setTimeout(() => {
      // second 'sure' update because of layout anims
      this.sizeUpdate();
    }, 300);
  }

  sizeUpdate() {
    const docW = Number(document.documentElement.clientWidth);

    // get width
    const width = this.homeRef.current.clientWidth;

    // get height
    let height = HEIGHT[2];
    if (docW > LIMITS[0]) {
      height = HEIGHT[0]; // eslint-disable-line prefer-destructuring
    } else if (docW > LIMITS[1]) {
      height = HEIGHT[1]; // eslint-disable-line prefer-destructuring
    }

    // calc bg size + pos
    let sMain = 0;
    const sW = width / BG_W;
    const sH = height / BG_H;

    if (sW > sH) {
      sMain = sW;
    } else {
      sMain = sH;
    }

    const rW = BG_W * sMain;
    const rH = BG_H * sMain;
    this.setState({
      bgW: rW,
      bgH: rH,
      bgLeft: -(rW - width) * 0.5,
      bgTop: -(rH - height) * 0.5,
    });
  }

  // -----------------------------------------------------------------------------------
  // Render
  // -----------------------------------------------------------------------------------

  render() {
    const { loadBgs, activeBg, bgW, bgH, bgTop, bgLeft } = this.state;

    const bgStyle = {
      width: bgW,
      height: bgH,
      top: bgTop,
      left: bgLeft,
    };

    const images = BGS.map(bgId => {
      let imgSrc = '';
      if (loadBgs === true || bgId === activeBg) {
        imgSrc = `${PATH.IMG}home/${bgId}.jpg`;
      }
      return (
        <img
          key={`home-bg-${bgId}`}
          className={`home-image ${bgId === activeBg ? 'active' : ''}`}
          alt=""
          src={imgSrc}
        />
      );
    });

    return (
      <div id="home" ref={this.homeRef}>
        <div id="home-bg-wrap" style={bgStyle}>
          {images}
          <div id="home-wrap-gradient" className="show" />
        </div>
        <div id="home-overlay" className="show" />
      </div>
    );
  }
}

export default withRouter(Home);



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/Home/Home.js